import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getAllVenueFacilities } from '../../services/api';

// Async thunk for fetching venue facilities
export const fetchVenueFacilities = createAsyncThunk(
  'venueFacilities/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAllVenueFacilities();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const venueFacilitiesSlice = createSlice({
  name: 'venueFacilities',
  initialState: {
    facilities: [],
    loading: false,
    error: null,
    selectedFacilities: []
  },
  reducers: {
    selectFacility: (state, action) => {
      const facilityId = action.payload;
      if (!state.selectedFacilities.includes(facilityId)) {
        state.selectedFacilities.push(facilityId);
      }
    },
    unselectFacility: (state, action) => {
      const facilityId = action.payload;
      state.selectedFacilities = state.selectedFacilities.filter(id => id !== facilityId);
    },
    clearSelectedFacilities: (state) => {
      state.selectedFacilities = [];
    },
    setSelectedFacilities: (state, action) => {
      state.selectedFacilities = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchVenueFacilities.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVenueFacilities.fulfilled, (state, action) => {
        state.loading = false;
        state.facilities = action.payload.venueFacilities;
      })
      .addCase(fetchVenueFacilities.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { 
  selectFacility, 
  unselectFacility, 
  clearSelectedFacilities,
  setSelectedFacilities 
} = venueFacilitiesSlice.actions;

export default venueFacilitiesSlice.reducer; 